// extracted by mini-css-extract-plugin
export default {"container":"Dining_5_container__g-tcu"};